<template>
  <div class="clearfix">
    <nav class="site-navbar navbar navbar-default navbar-mega navbar-inverse"
    role="navigation">
      <div class="navbar-header">
        <button type="button" class="navbar-toggler hamburger hamburger-close navbar-toggler-left"
        data-toggle="menubar" v-bind:class="{ 'hided': !isShowSiteMenu }" v-on:click="showSiteMenu()">
          <span class="sr-only">Toggle navigation</span>
          <span class="hamburger-bar"></span>
        </button>
        <button type="button" class="navbar-toggler collapsed" data-target="#site-navbar-collapse"
        data-toggle="collapse">
          <i class="icon md-more" aria-hidden="true"></i>
        </button>
        <router-link class="navbar-brand navbar-brand-center" v-bind:to="`/${$route.params.namespace}/`">
          <img class="navbar-brand-logo navbar-brand-logo-normal" src="/static/images/byteark-logo.png" title="ByteArk">
        </router-link>
      </div>
      <div class="navbar-container container-fluid">
        <div class="collapse navbar-collapse navbar-collapse-toolbar" id="site-navbar-collapse">
          <ul class="nav navbar-toolbar navbar-right navbar-toolbar-right">
            <li class="nav-item dropdown">
              <a class="nav-link nav-service" data-toggle="dropdown" href="javascript:void(0)" title="Service" >
                <i class="icon md-apps" aria-hidden="true"></i>
              </a>
              <ul class="dropdown-menu dropdown-menu-right dropdown-menu-media switch-service" role="menu">
                <li class="dropdown-menu-header" role="presentation">
                  <h5>{{ $t("menu.services") }}</h5>
                </li>
                <li class="list-group" role="presentation">
                  <div data-role="container">
                    <div data-role="content">
                      <router-link v-bind:to="`/${$route.params.namespace}/`" class="non-link list-group-item bg-blue-grey-100" role="menuitem" target="_blank">
                        <div class="media">
                          <div class="media-left p-l-5 p-r-20">
                            <i class="icon md-account bg-red-600 white icon-circle" aria-hidden="true"></i>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">{{ $t("services.account.name") }} <span class="tag tag-danger pull-xs-right">{{ $t("services.current.state") }}</span></h6>
                            <p class="media-meta">{{ $t("services.account.shortDescription") }}</p>
                          </div>
                        </div>
                      </router-link>
                      <a v-bind:href="serviceS3URL" class="non-link list-group-item" role="menuitem" target="_blank">
                        <div class="media">
                          <div class="media-left p-l-5 p-r-20">
                            <i class="icon md-storage bg-blue-600 white icon-circle" aria-hidden="true"></i>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">{{ $t("services.storage.name") }}</h6>
                            <p class="media-meta">{{ $t("services.storage.shortDescription") }}</p>
                          </div>
                        </div>
                      </a>
                      <a v-bind:href="serviceQoderURL" class="non-link list-group-item" role="menuitem" target="_blank">
                        <div class="media">
                          <div class="media-left p-l-5 p-r-20">
                            <i class="icon md-videocam bg-blue-600 white icon-circle" aria-hidden="true"></i>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">{{ $t("services.qoder.name") }}</h6>
                            <p class="media-meta">{{ $t("services.qoder.shortDescription") }}</p>
                          </div>
                        </div>
                      </a>
                      <a v-bind:href="serviceFleetURL" class="non-link list-group-item" role="menuitem" target="_blank">
                        <div class="media">
                          <div class="media-left p-l-5 p-r-20">
                            <i class="icon md-swap-vertical bg-blue-600 white icon-circle" aria-hidden="true"></i>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">{{ $t("services.fleet.name") }}</h6>
                            <p class="media-meta">{{ $t("services.fleet.shortDescription") }}</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </li>
                <li class="dropdown-menu-footer" role="presentation">
                  <router-link v-bind:to="`/${$route.params.namespace}/`" class="dropdown-item ">
                    <i class="icon md-pin" aria-hidden="true"></i><span class="text hidden-sm-down">
                    {{ $t("services.current.use") }} {{ $t("services.account.name") }} </span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item nav-user clearfix dropdown">
              <a class="nav-link navbar-avatar" data-toggle="dropdown" href="#" aria-expanded="false"
              data-animation="scale-up" role="button">
                <span class="avatar avatar-online">
                  <img v-if="currentUser" class="img-fluid" v-bind:src="currentUser.display_image.sizes.default.url" alt="image-profile">
                  <img v-else class="img-fluid" src="/static/images/user.png" alt="image-profile">
                </span>
                <p class="username">{{this.currentUser.name}}</p>
              </a>
              <div class="dropdown-menu" role="menu">
                <router-link v-bind:to="`/${$route.params.namespace}/self/profile`" class="dropdown-item" role="menuitem">
                  <i class="icon md-account" aria-hidden="true"></i> {{ $t('menu.profile') }}
                </router-link>
                <router-link v-bind:to="`/${$route.params.namespace}/self/password`" class="dropdown-item" role="menuitem">
                  <i class="icon md-key" aria-hidden="true"></i> {{ $t('menu.password') }}
                </router-link>
                <div class="dropdown-divider"></div>
                <router-link v-bind:to="`/${$route.params.namespace}/logout`" class="dropdown-item" role="menuitem">
                  <i class="icon md-power" aria-hidden="true"></i> {{ $t('menu.logout') }}
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="site-menubar site-menubar-light" v-bind:class="{ 'show-site-menu': isShowSiteMenu }">
      <div class="site-menubar-body">
        <div>
          <ul class="site-menu" data-plugin="menu">
            <li class="site-menu-category">{{ $t('menu.general') }}</li>
            <li class="site-menu-item">
              <router-link v-bind:to="`/${$route.params.namespace}/dashboard`">
                <i class="site-menu-icon md-cloud-box" aria-hidden="true"></i>
                <span class="site-menu-title">{{ $t('menu.dashboard') }}</span>
              </router-link>
            </li>
            <li class="site-menu-item" v-if="showBillingMenu">
              <router-link v-bind:to="`/${$route.params.namespace}/billing`">
                <i class="site-menu-icon md-money-box" aria-hidden="true"></i>
                <span class="site-menu-title">{{ $t('menu.billing') }}</span>
              </router-link>
            </li>
            <li class="site-menu-item has-sub" v-bind:class="{ 'open': isShowSubMenuTeam }" v-if="showTeamMenu">
              <a data-dropdown-toggle="false" v-on:click="showSubMenuTeam()">
                <i class="site-menu-icon md-accounts-list"></i>
                <span class="site-menu-title">{{ $t('menu.team') }}</span>
                <span class="site-menu-arrow"></span>
              </a>
              <ul class="site-menu-sub" v-bind:class="{ 'is-shown': isShowSubMenuTeam }">
                <li class="site-menu-item">
                  <router-link v-bind:to="`/${$route.params.namespace}/team/members`" class="animsition-link">
                    <span class="site-menu-title">{{ $t('member.labels.members') }}</span>
                  </router-link>
                </li>
                <li class="site-menu-item">
                  <router-link v-bind:to="`/${$route.params.namespace}/team/setting`"  class="animsition-link">
                    <span class="site-menu-title">{{ $t('team.labels.setting') }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="site-menu-item has-sub" v-bind:class="{ 'open': isShowSubMenuAdmin }" v-if="showAdminMenu">
              <a data-dropdown-toggle="false" v-on:click="showSubMenuAdmin()">
                <i class="site-menu-icon md-developer-board" aria-hidden="true"></i>
                <span class="site-menu-title">{{ $t('menu.admin') }}</span>
                <span class="site-menu-arrow"></span>
              </a>
              <ul class="site-menu-sub" v-bind:class="{ 'is-shown': isShowSubMenuAdmin }">
                <li class="site-menu-item">
                  <router-link v-bind:to="`/${$route.params.namespace}/admin/client-usage-history`" class="animsition-link">
                    <span class="site-menu-title">{{ $t('menu.clientUsageHistory') }}</span>
                  </router-link>
                </li>
                <li class="site-menu-item">
                  <router-link v-bind:to="`/${$route.params.namespace}/admin/teams`" class="animsition-link">
                    <span class="site-menu-title">{{ $t("action.manageClientTeam") }}</span>
                  </router-link>
                </li>
                <li class="site-menu-item">
                  <router-link v-bind:to="`/${$route.params.namespace}/admin/addon-cost`" class="animsition-link">
                    <span class="site-menu-title">{{ $t('menu.addons') }}</span>
                  </router-link>
                </li>
                <li class="site-menu-item">
                  <router-link v-bind:to="`/${$route.params.namespace}/admin/transactions`" class="animsition-link">
                    <span class="site-menu-title">{{ $t('menu.creditTransaction') }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="site-menu-item has-sub" v-bind:class="{ 'open': isShowSubMenuReseller }" v-if="showResellerMenu">
              <a v-on:click="showSubMenuAdmin()">
                <i class="site-menu-icon md-group-work" aria-hidden="true"></i>
                <span class="site-menu-title">{{ $t('menu.reseller') }}</span>
              </a>
              <ul class="site-menu-sub" v-bind:class="{ 'is-shown': isShowSubMenuReseller }">
                <li class="site-menu-item">
                  <router-link v-bind:to="`/${$route.params.namespace}/reseller/teams`" class="animsition-link">
                    <span class="site-menu-title">{{ $t('action.manageClientTeam') }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="site-menu-item" v-if="!showAdminMenu">
              <router-link v-bind:to="`/${$route.params.namespace}/support`">
                <i class="site-menu-icon md-email" aria-hidden="true"></i>
                <span class="site-menu-title">{{ $t('menu.support') }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'currentUser',
      'getCurrentUserError',
    ]),
    showBillingMenu: function() {
      const userOfReseller = this.currentUser.team.is_reseller && this.currentUser.role === 'user';
      return (!this.currentUser.team.is_superadmin) || userOfReseller;
    },
    showTeamMenu: function() {
      return (this.currentUser.role === 'manager');
    },
    showDeactivateTeamMenu: function() {
      if (this.currentUser.team.is_reseller ||
          this.currentUser.team.has_reseller ||
          this.currentUser.team.is_superadmin) {
        return false;
      }

      return true;
    },
    showAdminMenu: function() {
      return (this.currentUser.role === 'manager' && this.currentUser.team.is_superadmin);
    },
    showResellerMenu: function() {
      return (this.currentUser.role === 'manager' && this.currentUser.team.is_reseller);
    },
    serviceS3URL: function() {
      if (this.currentUser) {
        const namespace = this.currentUser.team.namespace;
        return `${process.env.SERVICES.S3}${namespace}`;
      }
      return null;
    },
    serviceQoderURL: function() {
      if (this.currentUser) {
        const namespace = this.currentUser.team.namespace;
        return `${process.env.SERVICES.QODER}/${namespace}`;
      }
      return null;
    },
    serviceFleetURL: function() {
      if (this.currentUser) {
        const namespace = this.currentUser.team.namespace;
        return `${process.env.SERVICES.FLEET}/${namespace}`;
      }
      return null;
    },
  },
  data: function () {
    return {
      isNavbarShow: false,
      isShowSiteMenu: false,
      isShowSubMenuTeam: false,
      isShowSubMenuAdmin: false,
      isShowSubMenuReseller: false,
    };
  },
  methods: {
    showNavbar: function (value) {
      this.isNavbarShow = value;
    },
    showSiteMenu: function () {
      this.isShowSiteMenu = !this.isShowSiteMenu;
    },
    showSubMenuTeam: function () {
      this.isShowSubMenuTeam = !this.isShowSubMenuTeam;
      if (this.isShowSubMenuTeam) {
        this.isShowSubMenuAdmin = false;
        this.isShowSubMenuReseller = false;
      }
    },
    showSubMenuAdmin: function () {
      this.isShowSubMenuAdmin = !this.isShowSubMenuAdmin;
      if (this.isShowSubMenuAdmin) {
        this.isShowSubMenuTeam = false;
        this.isShowSubMenuReseller = false;
      }
    },
    showSubMenuReseller: function () {
      this.isShowSubMenuReseller = !this.isShowSubMenuReseller;
      if (this.isShowSubMenuReseller) {
        this.isShowSubMenuTeam = false;
        this.isShowSubMenuAdmin = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// NavBar.vue?31de26de